export const TENANT_WEBSITES_RESET_STATE = 'TENANT_WEBSITES_RESET_STATE';
export const TENANT_WEBSITES_CURRENT_ITEM = 'TENANT_WEBSITES_CURRENT_ITEM';

export const TENANT_WEBSITES_REQUEST_LOADING = 'TENANT_WEBSITES_REQUEST_LOADING';
export const TENANT_WEBSITES_REQUEST_SUCCESS = 'TENANT_WEBSITES_REQUEST_SUCCESS';
export const TENANT_WEBSITES_REQUEST_FAILED = 'TENANT_WEBSITES_REQUEST_FAILED';

export const TENANT_WEBSITES_CURRENT_ACTION = 'TENANT_WEBSITES_CURRENT_ACTION';
export const TENANT_WEBSITES_RESET_ACTION = 'TENANT_WEBSITES_RESET_ACTION';